import { TAG_VARIANTS } from '@private/components';

import { STATUS_VARIANTS } from 'components/Tags/Status/styled';

export enum TRANSACTIONS_KEYS {
  ALL = 'transactions',
  CASCADING = 'cascading',
  CHARGEBACK_STATISTICS = 'chargeback_statistics',
  OPERATION_HISTORY = 'operation_history',
  REPORTS = 'reports',
  ROUTING_HISTORY = 'routing_history',
  TRANSACTION_CARD = 'transaction_card',
  TRANSACTION_CUSTOMER = 'transaction_customer',
  TRANSACTION_DETAILS = 'transaction_details',
  WEBHOOKS = 'webhooks',
}

export enum TRANSACTIONS_TYPE {
  PAYOUT = 'PAYOUT',
  PURCHASE = 'PURCHASE',
  REFUND = 'REFUND',
}

export const TRANSACTIONS_TYPE_VARIANTS = {
  [TRANSACTIONS_TYPE.PAYOUT]: TAG_VARIANTS.WARNING,
  [TRANSACTIONS_TYPE.PURCHASE]: TAG_VARIANTS.SUCCESS,
  [TRANSACTIONS_TYPE.REFUND]: TAG_VARIANTS.ERROR,
};

export enum CHARGEBACK_STATE {
  CHARGEBACK_LOST = 'CHARGEBACK_LOST',
  CHARGEBACK_REFUNDED = 'CHARGEBACK_REFUNDED',
  CHARGEBACK_WON = 'CHARGEBACK_WON',
  CLAIM = 'CLAIM',
  MASTERCARD_FRAUD_REPORT = 'MASTERCARD_FRAUD_REPORT',
  VISA_FRAUD_REPORT = 'VISA_FRAUD_REPORT',
}

export enum EXIT_IFRAME_MODE {
  CURRENT_TAB = 'CURRENT_TAB',
  NEW_ADDITIONAL_TAB = 'NEW_ADDITIONAL_TAB',
  NEW_TAB = 'NEW_TAB',
}

export enum TRANSACTIONS_STATE {
  AUTHORIZED = 'AUTHORIZED',
  CANCELLED = 'CANCELLED',
  CASCADING_CONFIRMATION_STATE = 'CASCADING_CONFIRMATION_STATE',
  CHARGED_BACK = 'CHARGED_BACK',
  COMPLETED = 'COMPLETED',
  CREATED = 'CREATED',
  DECLINED = 'DECLINED',
  ERROR = 'ERROR',
  IN_PROGRESS = 'IN_PROGRESS',
  INVALID = 'INVALID',
  ON_HOLD = 'ON_HOLD',
  PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED',
  PENDING = 'PENDING',
  PENDING_AND_SEND_WEBHOOK = 'PENDING_AND_SEND_WEBHOOK',
  PENDING_CONFIRMATION_REQUIRED = 'PENDING_CONFIRMATION_REQUIRED',
  PENDING_INPUT_REQUIRED = 'PENDING_INPUT_REQUIRED',
  RECONCILIATION_REQUIRED = 'RECONCILIATION_REQUIRED',
  REFUND_REQUIRED = 'REFUND_REQUIRED',
  REFUNDED = 'REFUNDED',
  THREEDS_ENROLLED = 'THREEDS_ENROLLED',
  THREEDS_PASSED = 'THREEDS_PASSED',
  TIMEOUT = 'TIMEOUT',
  VOIDED = 'VOIDED',
  WAITING_FOR_WEBHOOK = 'WAITING_FOR_WEBHOOK',
}

export const TRANSACTIONS_STATE_TAG_VARIANTS: Record<TRANSACTIONS_STATE, TAG_VARIANTS> = {
  [TRANSACTIONS_STATE.AUTHORIZED]: TAG_VARIANTS.WARNING,
  [TRANSACTIONS_STATE.CANCELLED]: TAG_VARIANTS.GRAY,
  [TRANSACTIONS_STATE.CASCADING_CONFIRMATION_STATE]: TAG_VARIANTS.WARNING,
  [TRANSACTIONS_STATE.CHARGED_BACK]: TAG_VARIANTS.ERROR,
  [TRANSACTIONS_STATE.COMPLETED]: TAG_VARIANTS.SUCCESS,
  [TRANSACTIONS_STATE.CREATED]: TAG_VARIANTS.GRAY,
  [TRANSACTIONS_STATE.DECLINED]: TAG_VARIANTS.ERROR,
  [TRANSACTIONS_STATE.ERROR]: TAG_VARIANTS.ERROR,
  [TRANSACTIONS_STATE.IN_PROGRESS]: TAG_VARIANTS.WARNING,
  [TRANSACTIONS_STATE.INVALID]: TAG_VARIANTS.ERROR,
  [TRANSACTIONS_STATE.ON_HOLD]: TAG_VARIANTS.WARNING,
  [TRANSACTIONS_STATE.PARTIALLY_REFUNDED]: TAG_VARIANTS.SUCCESS,
  [TRANSACTIONS_STATE.PENDING]: TAG_VARIANTS.WARNING,
  [TRANSACTIONS_STATE.PENDING_AND_SEND_WEBHOOK]: TAG_VARIANTS.WARNING,
  [TRANSACTIONS_STATE.PENDING_CONFIRMATION_REQUIRED]: TAG_VARIANTS.WARNING,
  [TRANSACTIONS_STATE.PENDING_INPUT_REQUIRED]: TAG_VARIANTS.WARNING,
  [TRANSACTIONS_STATE.RECONCILIATION_REQUIRED]: TAG_VARIANTS.WARNING,
  [TRANSACTIONS_STATE.REFUND_REQUIRED]: TAG_VARIANTS.GRAY,
  [TRANSACTIONS_STATE.REFUNDED]: TAG_VARIANTS.SUCCESS,
  [TRANSACTIONS_STATE.THREEDS_ENROLLED]: TAG_VARIANTS.WARNING,
  [TRANSACTIONS_STATE.THREEDS_PASSED]: TAG_VARIANTS.WARNING,
  [TRANSACTIONS_STATE.TIMEOUT]: TAG_VARIANTS.PRIMARY,
  [TRANSACTIONS_STATE.VOIDED]: TAG_VARIANTS.ERROR,
  [TRANSACTIONS_STATE.WAITING_FOR_WEBHOOK]: TAG_VARIANTS.WARNING,
};

export const TRANSACTIONS_STATE_STATUS_VARIANTS: Record<
  TRANSACTIONS_STATE,
  STATUS_VARIANTS
> = {
  [TRANSACTIONS_STATE.AUTHORIZED]: STATUS_VARIANTS.WARNING,
  [TRANSACTIONS_STATE.CANCELLED]: STATUS_VARIANTS.NEUTRAL,
  [TRANSACTIONS_STATE.CASCADING_CONFIRMATION_STATE]: STATUS_VARIANTS.WARNING,
  [TRANSACTIONS_STATE.CHARGED_BACK]: STATUS_VARIANTS.ERROR,
  [TRANSACTIONS_STATE.COMPLETED]: STATUS_VARIANTS.SUCCESS,
  [TRANSACTIONS_STATE.CREATED]: STATUS_VARIANTS.NEUTRAL,
  [TRANSACTIONS_STATE.DECLINED]: STATUS_VARIANTS.ERROR,
  [TRANSACTIONS_STATE.ERROR]: STATUS_VARIANTS.ERROR,
  [TRANSACTIONS_STATE.IN_PROGRESS]: STATUS_VARIANTS.WARNING,
  [TRANSACTIONS_STATE.INVALID]: STATUS_VARIANTS.ERROR,
  [TRANSACTIONS_STATE.ON_HOLD]: STATUS_VARIANTS.WARNING,
  [TRANSACTIONS_STATE.PARTIALLY_REFUNDED]: STATUS_VARIANTS.SUCCESS,
  [TRANSACTIONS_STATE.PENDING]: STATUS_VARIANTS.WARNING,
  [TRANSACTIONS_STATE.PENDING_AND_SEND_WEBHOOK]: STATUS_VARIANTS.WARNING,
  [TRANSACTIONS_STATE.PENDING_CONFIRMATION_REQUIRED]: STATUS_VARIANTS.WARNING,
  [TRANSACTIONS_STATE.PENDING_INPUT_REQUIRED]: STATUS_VARIANTS.WARNING,
  [TRANSACTIONS_STATE.RECONCILIATION_REQUIRED]: STATUS_VARIANTS.WARNING,
  [TRANSACTIONS_STATE.REFUND_REQUIRED]: STATUS_VARIANTS.NEUTRAL,
  [TRANSACTIONS_STATE.REFUNDED]: STATUS_VARIANTS.SUCCESS,
  [TRANSACTIONS_STATE.THREEDS_ENROLLED]: STATUS_VARIANTS.WARNING,
  [TRANSACTIONS_STATE.THREEDS_PASSED]: STATUS_VARIANTS.WARNING,
  [TRANSACTIONS_STATE.TIMEOUT]: STATUS_VARIANTS.PRIMARY,
  [TRANSACTIONS_STATE.VOIDED]: STATUS_VARIANTS.ERROR,
  [TRANSACTIONS_STATE.WAITING_FOR_WEBHOOK]: STATUS_VARIANTS.WARNING,
};

export const TRANSACTIONS_STATE_VARIANTS: Record<string, string> = {
  [TRANSACTIONS_STATE.CANCELLED]: 'error',
  [TRANSACTIONS_STATE.COMPLETED]: 'success',
  [TRANSACTIONS_STATE.DECLINED]: 'error',
  [TRANSACTIONS_STATE.ERROR]: 'error',
  [TRANSACTIONS_STATE.INVALID]: 'error',
  [TRANSACTIONS_STATE.PARTIALLY_REFUNDED]: 'success',
  [TRANSACTIONS_STATE.REFUNDED]: 'success',
  [TRANSACTIONS_STATE.TIMEOUT]: 'error',
};

export enum OPERATION_STATE {
  COMPLETED = 'completed',
  CONFLICT = 'conflict',
  ERROR = 'error',
  IN_PROGRESS = 'in_progress',
}

export const OPERATION_STATE_TAG = {
  [OPERATION_STATE.COMPLETED]: STATUS_VARIANTS.SUCCESS,
  [OPERATION_STATE.CONFLICT]: STATUS_VARIANTS.WARNING,
  [OPERATION_STATE.ERROR]: STATUS_VARIANTS.ERROR,
  [OPERATION_STATE.IN_PROGRESS]: STATUS_VARIANTS.PRIMARY,
};

export enum TRANSACTION_STATUS {
  ANY = 'ANY',
  DECLINE = 'DECLINE',
  SUCCESS = 'SUCCESS',
}

export const TRANSACTION_STATUS_TAG = {
  [TRANSACTION_STATUS.ANY]: TAG_VARIANTS.WARNING,
  [TRANSACTION_STATUS.DECLINE]: TAG_VARIANTS.ERROR,
  [TRANSACTION_STATUS.SUCCESS]: TAG_VARIANTS.SUCCESS,
};

export const INITIAL_ON_COLUMNS_TRANSACTIONS = [
  'checkboxes',
  'id',
  'merchantTerminalName',
  'amount',
  'currency',
  'state',
  'type',
  'created',
];

export const MAIN_COLUMNS = ['id'];

export const DEFAULT_LIKES_FIELDS = [
  'customerEmail',
  'terminalLinkDescription',
  'routingRulesetName',
];

export enum EXTRA_DETAILS_TYPE {
  ADDITIONAL = 'ADDITIONAL',
  CALLBACK = 'CALLBACK',
  REQUEST = 'REQUEST',
}

export enum GRID_SECTIONS {
  BASE_DETAILS = 'BASE_DETAILS',
  CARD_INFO = 'CARD_INFO',
  CLIENT = 'CLIENT',
  COMPANY = 'COMPANY',
  PROVIDER = 'PROVIDER',
}

export enum TRANSACTIONS_SETTINGS_KEYS {
  CASCADING = 'TRANSACTION_CASCADING',
  OPERATION_HISTORY = 'TRANSACTION_OPERATION_HISTORY',
  WEBHOOKS = 'TRANSACTION_WEBHOOKS',
}
